export const TaskProcessingStatus: { value: string; text: string }[] = [
  { value: 'NotProcessed', text: 'Не обработано' },
  { value: 'InProcessing', text: 'В обработке' },
  { value: 'Processed', text: 'Обработано' },
];

const TASK_STATUS_ALIASES: Record<string, string> = {
  not_processed: 'Не обработано',
  in_processing: 'В обработке',
  processed: 'Обработано',
};

export const TASK_STATUS_TEXT: Record<string, string> = {
  ...Object.fromEntries(TaskProcessingStatus.map((s) => [s.value, s.text])),
  ...TASK_STATUS_ALIASES,
};

export const taskStatusSortWeight = (value?: string): number => {
  if (value === 'NotProcessed' || value === 'not_processed') return 0;
  if (value === 'InProcessing' || value === 'in_processing') return 1;
  if (value === 'Processed' || value === 'processed') return 2;
  return 3;
};

export const taskStatusLabel = (value?: string): string =>
  TASK_STATUS_TEXT[value ?? ''] ?? value ?? 'Не обработано';

export const journalTaskStatusLabel = (value?: string): string =>
  value === 'NotProcessed' || value === 'not_processed'
    ? 'В очереди'
    : taskStatusLabel(value);
